import { useState } from "react";
import { Loader2, MapPin, Printer, Truck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function MondialRelayOrderInfo({ order, onDone }) {
  const [busy, setBusy] = useState(false);
  const rp = order.shipping?.relay_point;
  if (!rp) return null;
  const label = order.mondial_relay;

  const create = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/orders/${order.session_id}/mondial-relay-label`);
      toast.success(`Étiquette créée (n° ${data.expedition_num})`);
      window.open(data.label_url, "_blank", "noopener");
      onDone();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Création de l'étiquette impossible");
    } finally {
      setBusy(false);
    }
  };

  const btn = "inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium transition-colors";
  return (
    <li data-testid={`order-relay-point-${order.session_id}`} className="rounded-lg bg-amber-50 px-3 py-2 text-xs text-bark">
      <span className="flex items-center gap-1.5 font-semibold"><MapPin size={12} className="text-amber-deep" /> Point Relais n° {rp.id} : {rp.name}</span>
      <span className="block text-bark-soft">{rp.address}, {rp.postal_code} {rp.city}</span>
      <span className="mt-1.5 flex flex-wrap items-center gap-2">
        {label ? (
          <>
            <span data-testid={`order-mr-expedition-${order.session_id}`} className="font-medium">Expédition n° {label.expedition_num}</span>
            <a data-testid={`order-mr-label-${order.session_id}`} href={label.label_url} target="_blank" rel="noopener noreferrer" className={`${btn} bg-amber-deep text-white hover:bg-honey`}><Printer size={11} /> Imprimer l'étiquette</a>
            <a data-testid={`order-mr-tracking-${order.session_id}`} href={label.tracking_url} target="_blank" rel="noopener noreferrer" className={`${btn} border border-amber-800/25 bg-white text-bark hover:border-amber-deep`}><Truck size={11} /> Suivi du colis</a>
          </>
        ) : order.payment_status === "paid" && (
          <button data-testid={`order-mr-create-label-${order.session_id}`} disabled={busy} onClick={create} className={`${btn} bg-amber-deep text-white hover:bg-honey disabled:opacity-60`}>
            {busy ? <Loader2 size={11} className="animate-spin" /> : <Printer size={11} />} Créer l'étiquette Mondial Relay
          </button>
        )}
      </span>
    </li>
  );
}
